import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';

/** Stands in for a pbx row while the first fetches are still out. It borrows
 *  the queue row's own geometry - BaseListItem's p-2, PbxListItem's gap-x-2,
 *  and the avatar at the size and corner radius Avatar draws it - so the rows
 *  settle into place rather than shifting as each slice arrives. Padding plus
 *  the avatar comes to LIST_ITEM_HEIGHT, the height the virtualized list
 *  gives a real row.
 *
 *  Composed from the Skeleton parts rather than wrapped in Skeleton itself,
 *  whose gap is wider than a list row's. */
const PbxListItemSkeleton = () => (
    <div className="animate-fade flex w-full items-center gap-x-2 p-2 text-gray-200">
        <Skeleton.Avatar className="size-10 shrink-0 rounded-xl" />

        <div className="flex w-full flex-col gap-y-2">
            <Skeleton.Title className="w-2/5" />
            <Skeleton.Text className="w-4/5" />
        </div>
    </div>
);

const PbxListSkeleton = () => (
    <div className="w-full">
        {/* The real list always opens on a section title - see SectionTitle,
            whose h-6 is LIST_HEADER_ITEM_HEIGHT. */}
        <div className="animate-fade flex h-6 items-center ps-2 text-gray-200">
            <Skeleton.Text className="w-20" />
        </div>

        {/* Written out rather than mapped, as TicketsListSkeleton does:
            placeholder rows have no identity to key on. */}
        <PbxListItemSkeleton />
        <PbxListItemSkeleton />
        <PbxListItemSkeleton />
        <PbxListItemSkeleton />
        <PbxListItemSkeleton />
        <PbxListItemSkeleton />
    </div>
);

export default PbxListSkeleton;
